import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2"; // ✅ Import SweetAlert2
import API_BASE_URL from "../config/api"; // ✅ Import API base URL

function OtpVerification() {
  const navigate = useNavigate();
  const location = useLocation();
  const userid = location.state?.userid; // Get userid from Signup

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Redirect if no userid is passed
  useEffect(() => {
    if (!userid) {
      navigate("/signup");
    }
  }, [userid, navigate]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const otpCode = otp.join("");
    if (otpCode.length < 6) {
      setError("Please enter the 6-digit OTP.");
      return;
    }

    setLoading(true);
    try {
    
      const response = await axios.post(
  `${API_BASE_URL}/verifyotp.php`,
  {
    userid: userid,
    otp: otpCode
  },
  {
    headers: {
      "Content-Type": "application/json"
    }
  }
);

      if (response.data.success) {
        
        
        await Swal.fire({
          title: "OTP Verified",
          text: response.data.message || "Your account has been successfully verified.",
          icon: "success", 
          timer: 2000,
          timerProgressBar: true,
        });

        // Store user data in sessionStorage
        const user = response.data.user;
        sessionStorage.setItem("user", JSON.stringify(user));
        sessionStorage.setItem("verifyNo", "Y");
        // Redirect to Student Dashboard
        navigate("/subscription");
      } else {
        
        Swal.fire({
          title: "Invalid OTP",
          text: response.data.message || "Please try again.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="gray-simple">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8 col-md-10">
            <div className="card rounded-4 p-4">
              {/* Logo */}

              <h4 className="text-center mb-2">OTP Verification</h4>
              <p className="text-center mb-3">
                We have sent a 6-digit OTP to your registered mobile/email
              </p>

              {error && <p className="text-danger fw-bold text-center">{error}</p>}

              <form
                onSubmit={handleSubmit}
                className="d-flex flex-column align-items-center gap-3"
              >
                <div className="d-flex justify-content-center gap-2 mb-3">
                  {otp.map((digit, idx) => (
                    <input
                      key={idx}
                      id={`otp-${idx}`}
                      type="text"
                      maxLength="1"
                      className="form-control text-center border border-secondary"
                      style={{ width: "50px", fontSize: "20px" }}
                      value={digit}
                      onChange={(e) => handleChange(e, idx)}
                    />
                  ))}
                </div>

                <button
                  type="submit"
                  className="btn btn-main w-100"
                  disabled={loading}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </form>

              <p className="text-center mt-3">
                Didn't receive OTP?{" "}
                <span
                  className="text-primary"
                  style={{ cursor: "pointer" }}
                >
                  Resend
                </span>
              </p>

              <p className="text-center mt-2">
                <Link to="/signup" className="text-main">
                  Back to Signup
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OtpVerification;
